import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '数据对象',
    type: 'BDRULE_3',
}
